import { useEffect } from 'react';
import { useGet } from 'hooks/useGet';
import { SUBSCRIPTIONS_GET_BY_COMPANY } from 'apiRoutes';
import { Subscription } from 'domain/subscription/interfaces/Subscription';
import { isPayingCustomer } from 'domain/subscription/isPayingCustomer';

export const useIsCompanyPayingCustomer = (
	companyId?: number,
	applicationIds?: string[],
) => {
	const { getData, data, status } = useGet<Subscription[]>(
		companyId
			? `${SUBSCRIPTIONS_GET_BY_COMPANY}?companyId=${companyId}`
			: '',
	);

	useEffect(() => {
		if (companyId) getData();
	}, [companyId]);

	return {
		isPayingCustomer: isPayingCustomer(data, applicationIds),
		status,
	};
};
